import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from 'src/app/_models/user.model';
import { PwRecoverService } from 'src/app/_services/pwrecover.service';
import { StorageService } from 'src/app/_services/storage.service';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { Routes } from 'src/app/_config/routes.config';

@Component({
  selector: 'DCO-pwrecovery',
  templateUrl: './pwrecovery.component.html',
  standalone: false,
  styleUrls: [],
})
export class PwrecoveryComponent extends BaseComponent implements OnInit {
  private userSuscription!: Subscription;
  isLoggedIn = false;
  blockButton = false;
  resetPasswordSent = false;
  componentSelected: string;
  userLocal: string = '';
  user: any = {
    userName: '',
  };
  text = '';

  constructor(
    public override router: Router,
    public override langService: LanguageManagerService,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private pwRecoverService: PwRecoverService
  ) {
    super(router, langService, route);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.userSuscription = this.storageService.userInfo.subscribe((user) => {
      this.updateUserData(user);
    });
  }

  sendUSerPwRec() {
    this.text = '';
    this.user.userName = this.userLocal;
    if(this.userLocal ==''){
      return;
    }
    this.blockButton = true;
    this.resetPasswordSent = false;
    this.pwRecoverService.PwRecovermethod(this.user).then((response) => {
      this.blockButton = false;
      this.resetPasswordSent = true;
      //this.text = 'Compruebe el correo asociado a la cuenta';
    });
  }
  NavigateLogin(){
    this.router.navigate([Routes.LOGIN]);
  }
  updateUserData(user: User) {
    if (user != null && user.user) {
      this.isLoggedIn = true;
      this.router.navigate([Routes.DEFAULT]);
    } else {
      this.isLoggedIn = false;
    }
  }
}
